import { useGetList, useRecordContext } from "ra-core";
import { RecordField } from "@/components/admin/record-field";
import { ReferenceField } from "@/components/admin/reference-field";
import { Show } from "@/components/admin/show";
import { Card, CardContent } from "@/components/ui/card";

import { StatusBadge } from "../faromarket-shared/StatusBadge";

const StatusField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.status} kind="automation_status" />;
};

const RunLogsList = () => {
  const record = useRecordContext();
  const { data: logs, isPending } = useGetList(
    "automation_run_logs",
    {
      filter: { automation_run_id: record?.id },
      pagination: { page: 1, perPage: 100 },
      sort: { field: "created_at", order: "ASC" },
    },
    { enabled: !!record?.id },
  );

  if (isPending) return null;
  if (!logs?.length)
    return <p className="text-sm text-muted-foreground">Sem passos registrados.</p>;

  return (
    <div className="flex flex-col gap-2">
      {logs.map((log) => (
        <div
          key={log.id}
          className="rounded-md border border-border p-3 text-sm flex flex-col gap-1"
        >
          <div className="flex items-center gap-2">
            <StatusBadge value={log.status} kind="automation_status" />
            <span className="font-medium">
              {log.step_name ?? log.step_key ?? `#${log.id}`}
            </span>
          </div>
          {log.message && (
            <p className="text-muted-foreground text-xs">{log.message}</p>
          )}
          {log.error_message && (
            <p className="text-red-700 dark:text-red-300 text-xs">
              {log.error_message}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export const AutomationRunShow = () => (
  <Show>
    <Card>
      <CardContent className="grid gap-4 md:grid-cols-2">
        <RecordField
          source="automation_key"
          label="resources.automation_runs.fields.automation_key"
        />
        <RecordField
          source="status"
          label="resources.automation_runs.fields.status"
        >
          <StatusField />
        </RecordField>
        <RecordField
          source="automation_name"
          label="resources.automation_runs.fields.automation_name"
        />
        <RecordField
          source="trigger_type"
          label="resources.automation_runs.fields.trigger_type"
        />
        <RecordField
          source="trigger_source"
          label="resources.automation_runs.fields.trigger_source"
        />
        <RecordField
          source="started_at"
          label="resources.automation_runs.fields.started_at"
        />
        <RecordField
          source="finished_at"
          label="resources.automation_runs.fields.finished_at"
        />
        <RecordField
          source="duration_ms"
          label="resources.automation_runs.fields.duration_ms"
        />
        <RecordField
          source="form_submission_id"
          label="resources.automation_runs.fields.form_submission_id"
        >
          <ReferenceField
            source="form_submission_id"
            reference="form_submissions"
            link="show"
            empty="—"
          />
        </RecordField>
        <RecordField
          source="lead_id"
          label="resources.automation_runs.fields.lead_id"
        >
          <ReferenceField
            source="lead_id"
            reference="leads"
            link="show"
            empty="—"
          />
        </RecordField>
        <RecordField
          source="company_id"
          label="resources.automation_runs.fields.company_id"
        >
          <ReferenceField
            source="company_id"
            reference="companies"
            link="show"
            empty="—"
          />
        </RecordField>
        <RecordField
          source="contact_id"
          label="resources.automation_runs.fields.contact_id"
        >
          <ReferenceField
            source="contact_id"
            reference="contacts"
            link="show"
            empty="—"
          />
        </RecordField>
        <RecordField
          source="error_message"
          label="resources.automation_runs.fields.error_message"
          className="md:col-span-2"
        />
      </CardContent>
    </Card>
    <Card className="mt-4">
      <CardContent>
        <h3 className="text-lg font-semibold mb-3">Passos da execução</h3>
        <RunLogsList />
      </CardContent>
    </Card>
  </Show>
);
